import React, { useState } from "react";
import {
  FaSearch,
  FaUser,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { usePayrollContext } from "../../../Context/PayrollContext";

const VerifyAttendence = () => {
  const { baseUrl, openToast } = useGlobalContext();
  const {
    selectAllInput,
    calculateTotalFineAndOvertime,
    calculateDailySalary,
    staffs,
  } = usePayrollContext();
  console.log("staffs", selectAllInput);
  const [searchQuery, setSearchQuery] = useState("");
  const [isExpanded, setIsExpanded] = useState(null);
  const navigate = useNavigate();
  if (selectAllInput.length === 0) {
    navigate(-1);
  }

  function getDayIndex(day) {
    const days = ["One", "Two", "Three", "Four", "Five"];
    return days[day];
  }

  return (
    <div className="bg-white p-2 sm:p-4 md:p-8">
      {/* Header */}
      <h1 className="mb-4 md:mb-6 font-semibold text-[#27004a] text-lg sm:text-xl md:text-2xl">
        Verify Attendance
      </h1>

      {/* Search Bar */}
      <div className="relative mb-4 sm:mb-6 md:mb-8">
        <FaSearch className="top-3 left-4 absolute text-gray-400" />
        <input
          type="text"
          placeholder="Search by person name"
          className="py-2 pr-4 pl-12 border focus:border-blue-500 rounded-lg w-full text-sm focus:outline-none"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      {/* Table Header */}
      <div className="gap-2 md:gap-4 hidden sm:grid grid-cols-5 bg-gray-50 mb-4 p-2 sm:p-[12px] rounded-lg text-xs md:text-sm verify-att">
        <div className="">
          <span className="font-medium text-[12px] md:text-[14px]">EMPLOYEE ID</span>
        </div>
        <div className="">
          <span className="font-medium text-[12px] md:text-[14px]">NAME</span>
        </div>
        <div className="">
          <span className="font-medium text-[12px] md:text-[14px]">WORKED ON</span>
        </div>
        <div className="">
          <span className="font-medium text-[12px] md:text-[14px]">ABSENT</span>
        </div>
        <div className="">
          <span className="font-medium text-[12px] md:text-[14px]">PAYABLE</span>
        </div>
      </div>

      {/* Employee Row */}
      <div className="mb-4 border rounded-lg">
        {/* Header Row */}
        {selectAllInput.length > 0 &&
          selectAllInput.map((staff, index) => {
            let formattedTotal = 0;
            let formattedPending = 0;
            let pending = 0;
            let totalEarnings = 0;
            let paid = 0;
            let totalWeekOffs = 0;
            const punchRecords = staff?.staffDetails?.PunchRecords || [];
            const salaryDetails = staff?.staffDetails?.SalaryDetails[0] || {};
            const paymentHistory = salaryDetails.PaymentHistory || [];

            console.log("staff", staff);

            // Calculate payables
            const presentCount = punchRecords?.filter(
              (punch) => punch?.status === "PRESENT"
            ).length;
            totalWeekOffs = punchRecords?.filter(
              (punch) => {
                const date = new Date(punch?.punchDate);
                console.log(date.getMonth());
                return date.getDay() === 0;
              }
            ).length;
            const halfDayCount = punchRecords?.filter(
              (punch) => punch?.status === "HALFDAY"
            ).length;
            const absentCount = punchRecords?.filter(
              (punch) => punch?.status === "ABSENT"
            ).length - totalWeekOffs;
            const paidLeaveCount = punchRecords?.filter(
              (punch) => punch?.status === "PAIDLEAVE"
            ).length;
            const payables = presentCount + halfDayCount * 0.5 + totalWeekOffs + paidLeaveCount;
            if (staff?.staffDetails?.SalaryDetails[0]) {
              const fineAndOvertime =
                calculateTotalFineAndOvertime(punchRecords);
              console.log(fineAndOvertime);
              paid =
                paymentHistory.length > 0
                  ? paymentHistory.reduce(
                    (total, payment) => total + (payment?.amount || 0),
                    0
                  )
                  : 0;

              const dailySalary = calculateDailySalary(
                salaryDetails?.ctc_amount || 0
              );
              totalEarnings =
                payables * dailySalary + fineAndOvertime.totalOvertime;
              totalEarnings = totalEarnings - fineAndOvertime.totalFine;

              pending = totalEarnings - paid;

              formattedTotal =
                totalEarnings.toFixed(2) != NaN ? totalEarnings.toFixed(2) : 0;
              formattedPending =
                pending.toFixed(2) != NaN ? pending.toFixed(2) : 0;
            }

            return (
              <>
              <div className="flex flex-row justify-between items-center border-b last:border-b-0">
                <div
                  className="items-start sm:items-center gap-2 md:gap-4 grid grid-cols-2 sm:grid-cols-5 p-2 sm:p-[18px] w-full text-xs md:text-sm cursor-pointer verify-atte"
                  onClick={() => setIsExpanded((prev) => (prev === staff?.id ? null : staff?.id))}
                >
                  <div className="flex items-center gap-1 md:gap-3 col-span-2 sm:col-span-1">
                    <FaUser className="text-gray-400" />
                    <span className="sm:hidden mr-1 font-medium">ID:</span>
                    <span>{staff?.id?.split("-")?.[0]}</span>
                  </div>
                  <div className="col-span-2 sm:col-span-1">
                    <span className="sm:hidden mr-1 font-medium">Name:</span>
                    {staff?.name}
                  </div>
                  <div className="sm:ml-[15px]">
                    <span className="sm:hidden mr-1 font-medium">Worked:</span>
                    {presentCount + halfDayCount * 0.5} days
                  </div>
                  <div className="sm:ml-[12px]">
                    <span className="sm:hidden mr-1 font-medium">Absent:</span>
                    {absentCount} days
                  </div>
                  <div className="sm:ml-[30px]">
                    <span className="sm:hidden mr-1 font-medium">Payable:</span>
                    {payables}
                  </div>
                </div>
                <div className="flex-shrink-0 pr-2 sm:pr-[10px]">
                  {isExpanded === staff?.id ? (
                    <FaChevronUp className="view-btns" />
                  ) : (
                    <FaChevronDown className="view-btnss" />
                  )}
                </div>
              </div>

                {/* Detailed Breakdown - Collapsible */}
                {isExpanded === staff?.id && (
                  <div className="gap-2 md:gap-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 bg-white p-2 md:p-4 border-t rounded-b-[10px]">
                    {/* Left Column */}
                    <div className="space-y-2 bg-[#f6f6f6] p-2 md:p-4 rounded-lg text-xs md:text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Week Off</span>
                        <span>{totalWeekOffs}</span>
                      </div>
                    </div>

                    {/* Middle Column */}
                    {paidLeaveCount > 0 && (
                      <div className="space-y-2 bg-[#FDF4FF] p-2 md:p-4 rounded-lg text-xs md:text-sm">
                        {staff.staffDetails.LeavePolicy.length == 0 && (
                          <div className="flex justify-between">
                            <span className="text-gray-600">Leaves</span>
                            <span>{paidLeaveCount}</span>
                          </div>
                        )}
                        {staff.staffDetails.LeavePolicy.length > 0 &&
                          staff.staffDetails.LeavePolicy.map((leave) => (
                            <div className="flex justify-between">
                              <span className="text-gray-600">
                                {leave.name}
                              </span>
                              <span>{leave.allowed_leaves}</span>
                            </div>
                          ))}
                      </div>
                    )}

                    {/* Right Column */}
                    <div className="space-y-2 md:space-y-0">
                      <div className="space-y-2 bg-[#F0FDF4] mb-2 md:mb-4 p-2 md:p-4 rounded-lg text-xs md:text-sm">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Present</span>
                          <span>{presentCount}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Half Day</span>
                          <div className="text-right">
                            <span>{halfDayCount * 0.5}</span>
                            <span className="ml-1 text-[8px] text-gray-500 md:text-xs">
                              (1*0.5)
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-2 text-xs md:text-sm">
                      <div className="flex justify-between bg-[#e9f7fd] mb-1 md:mb-[4px] p-1 md:p-[6px] rounded-md">
                        <span className="text-gray-600">Worked On</span>
                        <span>{presentCount + halfDayCount * 0.5}</span>
                      </div>
                      <div className="flex justify-between bg-[#fceced] mb-1 md:mb-[4px] p-1 md:p-[6px] rounded-md">
                        <span className="text-gray-600">Absent</span>
                        <span>{absentCount}</span>
                      </div>
                    </div>

                    <div className="flex justify-center items-center bg-[#f4f4f4] p-2 md:p-4 rounded-md">
                      <div className="flex flex-col items-center">
                        <span className="font-medium text-3xl text-center md:text-5xl">
                          {payables}
                        </span>
                        <span className="text-center text-gray-600 text-xs md:text-sm">
                          Payable Days
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })}
      </div>

      {/* Footer Actions */}
      <div className="flex sm:flex-row flex-col justify-between items-center space-y-2 sm:space-y-0 mt-6 md:mt-8">
        <button onClick={() => navigate(-1)} className="border-gray-300 px-4 py-2 border rounded-md w-full sm:w-auto text-sm first-btn">
          Cancel
        </button>
        <Link
          to="/verify-salary"
          className="flex justify-center items-center bg-blue-600 px-4 py-2 rounded-md w-full sm:w-auto text-center text-sm text-white next-verify second-btn"
        >
          Next: Verify Salary
        </Link>
      </div>
    </div>
  );
};

export default VerifyAttendence;

